module.exports = __webpack_public_path__ + "e4f56917bedf2dcf39e7da41d8ff026a.svg";